export default "__VITE_ASSET__UVmMEnt4__"